<template>
  <div>
    <h1>研修・応援時間登録</h1>
    <p>
      事業所、参加者、開始、終了時間を設定し登録すると勤務実績に研修・応援時間が登録されます。
    </p>
    <v-divider></v-divider>
    <template>
      <v-row>
        <v-col colspan="6">
          <v-radio-group
            v-model="filterPattern"
            row
            label="対象:"
            prepend-icon="mdi-toggle-switch"
          >
            <v-radio label="研修" :value="SelectsPattern.Meetting"></v-radio>
            <v-radio label="応援" :value="SelectsPattern.Assist"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <div class="mt-5">
        <DatePicker
          v-model="targetdate"
          label="対象年月日"
          prepend-icon="mdi-calendar"
          type="day"
          outlined
        />
        <v-autocomplete
          v-model="selectShozoku"
          :items="shozokus"
          label="事業所"
          :rules="[Rules.Required]"
          outlined
          item-text="name"
          item-value="code"
          prepend-icon="mdi-form-select"
          return-object
        >
        </v-autocomplete>
        <v-autocomplete
          v-model="selectUser"
          :items="users"
          label="参加者"
          :rules="[Rules.Required]"
          outlined
          item-text="name"
          item-value="code"
          prepend-icon="mdi-form-select"
          clearable
          multiple
          chips
          return-object
        >
        </v-autocomplete>
        <div class="mb-4">
          <label class="ml-5 mr-2">開始時間</label>
          <v-icon class="mr-2">
            mdi-clock
          </v-icon>
          <vue-timepicker
            v-model="starttime"
            close-on-complete
            :format="timeFormat"
            placeholder="時間"
            :minute-interval="minInterval"
            hour-label="時"
            minute-label="分"
          ></vue-timepicker>
        </div>
        <div class="mb-4">
          <label class="ml-5 mr-2">終了時間</label>
          <v-icon class="mr-2">
            mdi-clock
          </v-icon>
          <vue-timepicker
            v-model="endtime"
            close-on-complete
            :format="timeFormat"
            placeholder="時間"
            :minute-interval="minInterval"
            hour-label="時"
            minute-label="分"
          ></vue-timepicker>
        </div>
        <div class="mb-4">
          <label class="ml-5 mr-2">総休憩時間</label>
          <v-icon class="mr-2">
            mdi-clock
          </v-icon>
          <vue-timepicker
            v-model="breaktime"
            close-on-complete
            :format="timeFormat"
            placeholder="時間"
            :minute-interval="minInterval"
            hour-label="時"
            minute-label="分"
          ></vue-timepicker>
        </div>
        <div v-if="filterPattern === SelectsPattern.Assist" class="mb-4">
          <label class="ml-5 mr-2">深夜休憩時間</label>
          <v-icon class="mr-2">
            mdi-clock
          </v-icon>
          <vue-timepicker
            v-model="midnightBreaktime"
            close-on-complete
            :format="timeFormat"
            placeholder="時間"
            :minute-interval="minInterval"
            hour-label="時"
            minute-label="分"
          ></vue-timepicker>
        </div>
        <v-row>
          <v-col colspan="6">
            <v-radio-group
              v-if="filterPattern === SelectsPattern.Assist"
              v-model="selectDayWork"
              row
              label="日跨ぎ:"
              prepend-icon="mdi-toggle-switch"
            >
              <v-radio label="しない" :value="SelectsDelete.Delete"></v-radio>
              <v-radio label="する" :value="SelectsDelete.Default"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-text-field
          v-if="filterPattern === SelectsPattern.Assist"
          v-model="enkachiTeate"
          label="遠隔地手当"
          prepend-icon="mdi-currency-jpy"
          type="number"
          min="0"
          outlined
          class="mb-4"
          suffix="円"
        ></v-text-field>
        <dib class="mb-4">
          <v-text-field
            v-model="bikou"
            label="備考"
            prepend-icon="mdi-text"
            outlined
          ></v-text-field>
        </dib>
        <!-- <TimePicker
          v-model="starttime"
          label="開始時間"
          prepend-icon="mdi-clock"
          :rules="[Rules.Required]"
          outlined
        />
        <TimePicker
          v-model="endtime"
          label="終了時間"
          prepend-icon="mdi-clock"
          :rules="[Rules.Required]"
          outlined
        /> -->
      </div>
    </template>
    <div class="d-flex flex-row-reverse">
      <v-btn type="login" color="info" @click="setdata">
        設定
      </v-btn>
    </div>
    <template v-if="isShow()">
      <table>
        <thead>
          <tr>
            <th v-for="(header, i) in setItemHeader" :key="i">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in setitems" :key="index">
            <td>{{ item.pattern }}</td>
            <td>{{ displayDate(item.targetDate) }}</td>
            <td>{{ item.affiliationName }}</td>
            <td>
              {{ item.username }}
            </td>
            <td>
              {{ item.starttime }}
            </td>
            <td>{{ item.endtime }}</td>
            <td>{{ item.breaktime }}</td>
            <td>{{ item.midnightBreaktime }}</td>
            <td>{{ item.enkachiTeate > 0 ? item.enkachiTeate + "円" : "" }}</td>
            <td>{{ item.bikou }}</td>
            <td>
              <v-icon
                small
                class="ml-1"
                color="error"
                @click="deleteRow(index)"
              >
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex flex-row-reverse mt-5">
        <v-btn type="login" color="success" @click="regist">
          登録
        </v-btn>
      </div>
    </template>
  </div>
</template>
<script>
import Common from "@/mixins/common";
import ShowDialogs from "@/mixins/showDialogs";
import Api from "@/mixins/api";
import Forms from "@/mixins/forms";
import Meeting from "@/models/Meeting";
import { BUSYO_CODE as BusyoCode } from "@/defines";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
const SelectsDelete = {
  Delete: "0",
  Default: "1"
};
const Reserveid1 = {
  Default: "1",
  DayOver: "2"
};
const DATE = new Date();
const DATENOW =
  DATE.getFullYear() +
  "-" +
  ("00" + Number(DATE.getMonth() + 1)).slice(-2) +
  "-" +
  ("00" + Number(DATE.getDate())).slice(-2);

const SelectsPattern = {
  Meetting: "1",
  Assist: "2"
};

export default {
  name: "MeetingAdd",
  components: { VueTimepicker },
  mixins: [Common, ShowDialogs, Forms, Api],
  computed: {},
  data() {
    return {
      targetdate: DATENOW,
      shozokus: [],
      selectShozoku: { code: "", name: "" },
      users: [],
      selectUser: [],
      starttime: "",
      endtime: "",
      breaktime: "",
      midnightBreaktime: "00:00",
      enkachiTeate: "0",
      bikou: "",
      setItemHeader: [
        "パターン",
        "対象年月日",
        "事業所",
        "社員氏名",
        "開始時間",
        "終了時間",
        "総休憩時間",
        "深夜休憩時間",
        "遠隔地手当",
        "備考",
        "action"
      ],
      timeFormat: "HH:mm",
      minInterval: 15,
      setitems: [],
      SelectsPattern,
      SelectsDelete,
      filterPattern: SelectsPattern.Meetting,
      selectDayWork: SelectsDelete.Delete,
      reserveid1: Reserveid1.Default
    };
  },
  methods: {
    isShow() {
      return this.setitems.length > 0;
    },
    setdata() {
      console.log("setdata");
      if (!this.validate()) return;
      this.selectUser.forEach(user => {
        const f = this.users.filter(e => e.code === user.code);
        const item = {
          patternId: this.filterPattern,
          pattern:
            this.filterPattern == SelectsPattern.Meetting ? "研修" : "応援",
          targetDate: this.targetdate,
          allifiationId: this.selectShozoku.code,
          affiliationName: this.selectShozoku.name,
          userincode: user.code,
          username: f[0].name,
          starttime: this.starttime,
          endtime: this.endtime,
          breaktime: this.breaktime,
          midnightBreaktime:
            this.filterPattern == SelectsPattern.Assist
              ? this.midnightBreaktime
              : "00:00",
          enkachiTeate:
            this.filterPattern == SelectsPattern.Assist
              ? Number(this.enkachiTeate) || 0
              : 0,
          bikou: this.bikou,
          dayWork:
            this.filterPattern == SelectsPattern.Assist
              ? this.selectDayWork
              : SelectsDelete.Delete,
          reserveid1:
            this.filterPattern == SelectsPattern.Assist &&
            this.selectDayWork == SelectsDelete.Default
              ? Reserveid1.DayOver
              : Reserveid1.Default
        };
        this.setitems.push(item);
        console.log("setitems", this.setitems);
      });
    },
    displayDate(targetDate) {
      const dt = targetDate.split("-");
      return dt[0] + "年" + dt[1] + "月" + dt[2] + "日";
    },
    async regist() {
      console.log("regist");
      this.$loading();
      try {
        const param = [];
        this.setitems.forEach(e => {
          const item = new Meeting(
            e.patternId,
            e.targetDate,
            e.allifiationId,
            e.userincode,
            e.starttime,
            e.endtime,
            e.breaktime,
            e.midnightBreaktime,
            e.enkachiTeate,
            e.bikou,
            e.dayWork,
            e.reserveid1
          );
          param.push(item);
        });

        await this.$post(this.Paths.meetingAdd, param);
        this.$info("更新しました。");
        this.setitems = [];
      } catch (e) {
        console.log(e);
        this.$error(e.message);
      } finally {
        this.$unloading();
      }
    },
    async deleteRow(index) {
      console.log("deleteRow", index);
      if (await this.deleteConfirm()) {
        this.setitems = this.setitems.filter((x, i) => i !== index);
      }
    },
    async deleteConfirm() {
      return await this.$deleteConfirm("削除します。\nよろしいですか？");
    },
    validate() {
      if (this.selectShozoku.code === "") {
        this.$warning("事業所を選択してください");
        return false;
      }
      if (this.selectUser.length == 0) {
        this.$warning("参加者を選択してください");
        return false;
      }
      if (this.starttime === "") {
        this.$warning("開始時間を設定してください");
        return false;
      }
      if (this.endtime === "") {
        this.$warning("終了時間を設定してください");
        return false;
      }
      if (this.breaktime == "") {
        this.$warning("休憩時間を設定してください");
        return false;
      }
      const dt = new Date();
      const start = new Date(
        dt.getFullYear(),
        dt.getMonth() + 1,
        dt.getDate(),
        this.starttime.split(":")[0],
        this.starttime.split(":")[1],
        0
      );
      const end = new Date(
        dt.getFullYear(),
        dt.getMonth() + 1,
        dt.getDate(),
        this.endtime.split(":")[0],
        this.endtime.split(":")[1],
        0
      );
      if (SelectsPattern.Assist === this.filterPattern) {
        // 応援の場合、日跨ぎ設定がある場合はチェック
        if (
          (end <= start && this.selectDayWork === SelectsDelete.Delete) ||
          (end > start && this.selectDayWork === SelectsDelete.Default)
        ) {
          this.$warning("開始時間と終了時間を正しく設定してください");
          return false;
        }
      } else {
        if (end <= start) {
          this.$warning("開始時間と終了時間を正しく設定してください");
          return false;
        }
      }
      return true;
    },
    async setPulldown() {
      const param = {
        code1: BusyoCode.WELFARE
      };
      const encode = encodeURI(JSON.stringify(param));
      this.shozokus = await this.$get(this.Paths.shozoku, "query=" + encode);
      this.users = await this.$get(this.Paths.shain1, "query=" + encode);
    }
  },
  async created() {
    console.log("created");
    this.$loading();
    try {
      await this.setPulldown();
    } catch (e) {
      console.log(e);
      this.$error(e.message);
    } finally {
      this.$unloading();
    }
  }
};
</script>
<style scoped>
table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

table th {
  text-align: start !important;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  width: 5%;
  padding: 10px 5px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.75rem;
}

table td {
  text-align: start !important;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  border-top: none;
  width: 5%;
  padding: 10px 5px;
  font-size: 0.875rem;
}
</style>
